module.exports = __webpack_public_path__ + "static/media/knight.80949924.jpg";